import Navbar from "../components/Navbar";
import Features from "../components/Features";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function FeaturesPage() {
    return (
        <div className="bg-background text-foreground min-h-screen">
            <Navbar />
            <main data-testid="features-page" className="pt-[4.75rem]">
                <Features />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
